/** Lit count lamp colors on the scoreboard. */
export const BALL_LAMP: [number, number, number] = [70, 244, 105]
export const STRIKE_LAMP: [number, number, number] = [255, 211, 55]
